import { useQuery, keepPreviousData } from "@tanstack/react-query";
import {
  getEvaluacionesSearch,
  getEvaluacionesResumen,
  getFirstClassDate,
} from "../api/evaluaciones-search";

export function useEvaluacionesSearch(params: Record<string, any>) {
  return useQuery({
    queryKey: ["eval-search", params],
    queryFn: () => getEvaluacionesSearch(params),
    placeholderData: keepPreviousData,
  });
}

export function useEvaluacionesResumen(params: Record<string, any>) {
  return useQuery({
    queryKey: ["eval-resumen", params],
    queryFn: () => getEvaluacionesResumen(params),
    placeholderData: keepPreviousData,
  });
}

export function useFirstClassDate(alumnoId: number | null) {
  return useQuery({
    queryKey: ["eval-first-date", alumnoId],
    enabled: !!alumnoId,
    queryFn: () => getFirstClassDate(alumnoId!),
  });
}
